import { render, staticRenderFns } from "./BaseEdge.vue?vue&type=template&id=905cc054&"
import script from "./BaseEdge.vue?vue&type=script&lang=ts&"
export * from "./BaseEdge.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports